import { notificationsGenerated } from './generated/notifications';


export const notifications = notificationsGenerated.enhanceEndpoints({});
